<template>
    <div>
        <div class="mb-2" style="font-size: 0.85rem">Diseases</div>
        <div>
            <div v-for="(disease, index) in diseases" class="w-1/2 mb-2" :key="index">
                <vx-checkbox
                    :label="disease.description"
                    :vs-value="disease"
                    v-model="localForm.medical.diseases"
                ></vx-checkbox>
            </div>
        </div>
        <div class="flex w-full flex-nowrap">
            <vx-date-input
                class="w-1/2 mr-4"
                v-model="localForm.medical.approvalGrantedDate"
                label="Date Approval Granted"
                clearable
            ></vx-date-input>
            <vx-input
                v-if="exceptionalCircumstancesSelected"
                class="w-1/2"
                v-model="localForm.medical.otherDetails"
                label="Exceptional Circumstances Details"
                name="Exceptional Circumstances Details"
                :rules="['required']"
                :maxlength="250"
            ></vx-input>
            <div v-else class="w-1/2" />
        </div>
        <vx-textarea
            label="Additional Notes"
            name="notes"
            icon-pack="feather"
            icon="icon-file-text"
            class="vx-textarea w-full text-area-height"
            v-model="localForm.medical.additionalNotes"
            remove-validation-padding
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'patient-medical-info-section',
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localForm: {
                medical: {
                    diseases: [],
                    approvalGrantedDate: null,
                    additionalNotes: null
                }
            }
        }
    },
    watch: {
        'exceptionalCircumstancesSelected': {
            handler: function (newV) {
                if (newV == false) {
                    this.localForm.medical.otherDetails = null
                }
            }
        },
        'localForm.medical': {
            handler: function (v) {
                if (v) {
                    // this.$emit('update:form', this.localForm)
                    // KNOWN HACK: to get around the fact that the above line doesn't work
                    // it doesnt work because the VX-dynamic-form is not :form.sync=""
                    this.$set(this.form, 'medical', v)
                }
            },
            deep: true
        },
        'form': {
            handler: function (newV, oldV) {
                if (newV) {
                    this.localForm = this.deepCopy(newV)

                    this.localForm.medical.diseases = this.localForm.medical.diseases.map((d) =>
                        this.diseases.first((di) => di.id == d.id)
                    )
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            diseases: 'maarima/diseases'
        }),
        exceptionalCircumstancesSelected() {
            return (
                this.localForm.medical.diseases &&
                this.localForm.medical.diseases.any((di) => di.id == 7)
            )
        }
    },
    methods: {},
    mounted() {}
}
</script>

<style lang="scss" scoped></style>
